'use client'

import React from 'react'
import ProfileHeader from './profile-header/profile-header'
import DeliveryOptions from './delivery/delivery-options'
import LocationCard from './location/location-card'
import BusinessHours from './business-hours/business-hours'
import styles from './styles.module.scss'
import DetailsCard from './details-card/details-card'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import LoadingMerchant from './profile-header/loading-merchant/loading-merchant'
import TypePayments from './payment-methods/payment-methods'
import BaseError from '@/src/components/helpers/base-error/base-error'

export default function MerchantProfile() {
    const { merchantDetailed: details } = useMerchant()

    if (details?.isLoading)
        return <LoadingMerchant />

    if (!details?.model || details?.error)
        return <BaseError message={"Houve um problema para obter os dados do restaurante, tente novamente mais tarde."} />

    return (
        <section className={styles.container}>
            <ProfileHeader merchant={details.model} />
            <DeliveryOptions option={details.model.deliveryConfiguration.deliveryOptions} />
            <LocationCard address={details.model.address} />
            <BusinessHours merchant={details.model} />
            <TypePayments paymentConfiguration={details.model.paymentConfiguration} />
            <DetailsCard document={details.model.documentNumber} companyName={details.model.companyName} />
        </section>
    )
}
